import API from '../config/api';
import React, { useEffect, useState } from 'react';

import axios from 'axios';

import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';

import { useParams, useNavigate } from 'react-router-dom';

import CustomNavbar from '../components/CustomNavbar';

import { confirmToast } from '../utils/toast';

function AdminCategoryProductsPage() {
  const { category } = useParams();

  const navigate = useNavigate();

  const [products, setProducts] = useState([]);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const { data } = await axios.get(
          `${API}/categories/products/${category}`
        );

        setProducts(data);
      } catch (error) {
        console.log(error);
      }
    };

    loadProducts();
  }, [category]);

  const deleteProduct = async (id) => {
    if (!(await confirmToast('Delete Product?'))) {
      return;
    }

    try {
      await axios.delete(`${API}/products/${id}`);

      const { data } = await axios.get(
        `${API}/categories/products/${category}`
      );

      setProducts(data);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <CustomNavbar />

      <div className="acp-wrap">
        <Container>
          {/* Header */}
          <Card className="border-0 shadow-lg mb-4 acp-hero">
            <span className="acp-hero-blob acp-hero-blob-1" />
            <span className="acp-hero-blob acp-hero-blob-2" />

            <Card.Body className="position-relative p-4 p-md-5 d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div>
                <h1 className="fw-bold mb-1 text-capitalize">📂 {category}</h1>
                <p className="mb-0 acp-hero-text">
                  {products.length} products in this category
                </p>
              </div>
              <Button
                variant="light"
                className="fw-semibold rounded-pill px-4 acp-back-btn"
                onClick={() => navigate('/admin/categories')}
              >
                ← Back to Categories
              </Button>
            </Card.Body>
          </Card>

          {/* Products */}
          {products.length === 0 ? (
            <Card
              className="border-0 shadow-sm text-center py-5"
              style={{ borderRadius: '20px' }}
            >
              <Card.Body>
                <div style={{ fontSize: '3rem' }}>📭</div>
                <h5 className="fw-bold mt-2">No Products in this Category</h5>
                <p className="text-muted mb-0">
                  Add products to see them here.
                </p>
              </Card.Body>
            </Card>
          ) : (
            <Row className="g-4">
              {products.map((product) => (
                <Col xl={3} lg={4} md={6} sm={6} xs={12} key={product._id}>
                  <Card className="border-0 shadow-sm h-100 acp-card">
                    <div className="acp-img-wrap">
                      {product.stock > 0 ? (
                        <Badge bg="success" className="acp-stock-badge">
                          {product.stock} in stock
                        </Badge>
                      ) : (
                        <Badge bg="danger" className="acp-stock-badge">
                          Out of stock
                        </Badge>
                      )}
                      <Card.Img
                        variant="top"
                        src={product.image}
                        alt={product.name}
                        className="acp-img"
                      />
                    </div>

                    <Card.Body className="d-flex flex-column p-3">
                      <h6 className="fw-bold acp-name mb-1">{product.name}</h6>

                      <h4 className="text-success fw-bold mb-3">
                        ₹{product.price}
                      </h4>

                      <div className="d-flex gap-2 mt-auto">
                        <Button
                          variant="outline-warning"
                          size="sm"
                          className="flex-fill fw-semibold"
                          onClick={() =>
                            navigate(`/admin/edit-product/${product._id}`)
                          }
                        >
                          ✏️ Edit
                        </Button>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          className="flex-fill fw-semibold"
                          onClick={() => deleteProduct(product._id)}
                        >
                          🗑 Delete
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </Container>
      </div>

      <style>{categoryProductsStyles}</style>
    </>
  );
}

const categoryProductsStyles = `
  .acp-wrap {
    background: radial-gradient(720px 320px at 8% -5%, rgba(124,58,237,0.12), transparent 70%), radial-gradient(720px 320px at 92% 105%, rgba(234,88,12,0.14), transparent 70%), linear-gradient(180deg, #faf5ff 0%, #fff7ed 55%, #fef3c7 100%);
    min-height: 100vh;
    padding: clamp(24px, 4vw, 40px) 0;
  }

  .acp-hero {
    border-radius: 25px;
    overflow: hidden;
    color: #fff;
    background: linear-gradient(120deg, #0f172a, #7c2d12 60%, #ea580c);
    position: relative;
  }
  .acp-hero-blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    opacity: 0.45;
    pointer-events: none;
  }
  .acp-hero-blob-1 {
    width: 200px; height: 200px;
    background: #f59e0b;
    top: -80px; right: 25%;
  }
  .acp-hero-blob-2 {
    width: 180px; height: 180px;
    background: #38bdf8;
    bottom: -90px; left: -30px;
    opacity: 0.3;
  }
  .acp-hero-text {
    opacity: 0.85;
  }
  .acp-back-btn {
    color: #7c2d12;
  }

  .acp-card {
    border-radius: 18px;
    overflow: hidden;
    border: 2px solid transparent !important;
    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
  }
  .acp-card:hover {
    transform: translateY(-8px);
    border-color: rgba(234, 88, 12, 0.35) !important;
    box-shadow: 0 22px 40px rgba(194, 65, 12, 0.2) !important;
  }
  .acp-img-wrap {
    position: relative;
    overflow: hidden;
    background: #f8fafc;
  }
  .acp-img {
    height: clamp(180px, 22vw, 230px);
    width: 100%;
    object-fit: contain;
    padding: 12px;
    transition: transform 0.45s ease;
  }
  .acp-card:hover .acp-img {
    transform: scale(1.08);
  }
  .acp-stock-badge {
    position: absolute;
    top: 12px; left: 12px;
    z-index: 2;
    border-radius: 30px;
    padding: 5px 12px;
    font-size: 0.72rem;
  }
  .acp-name {
    font-size: 1rem;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export default AdminCategoryProductsPage;
